import React from 'react';
import {Table,TableHead,makeStyles,TableRow,TableContainer,TableCell }from '@material-ui/core'
import { isEmpty } from 'lodash';

const useStyles = makeStyles({
        scrollBar: {
          overflowY: "auto",
          margin: 0,
          padding: 0,
          listStyle: "none",
          height: "100%",
          '&::-webkit-scrollbar': {
              height: '0.75em',
          },
          '&::-webkit-scrollbar-track': {
              boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
              webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
          },
          '&::-webkit-scrollbar-thumb': {
              backgroundColor: 'rgba(0,0,0,.4)',
              outline: 'none',
              borderRadius: 15
          },
        }
})
function FooterAR1(props) {
    const classes = useStyles();
    const [columns,setColumns] = React.useState([])
    React.useEffect(()=>{
        console.log(props.Mstate,"DDDDD1")
       let Coluums = []
       props.Mstate.filter(item=>{return item.Checked === true && !item.Meta.includes(".O.M")})
            .map(item=>{
            Coluums.push(
                { title: item.Meta, field: item.Meta, cellStyle: 
                    { width:'150px',textAlign: 'center', padding: '0px', border: '1px solid #000000', backgroundColor: '#fff', fontSize: 12 } 
                },
            )           
        })
        setColumns(Coluums)
        /**/
    },[props])
    return (
        <div>
            {
            isEmpty(columns)?"":
                <>
                 <TableContainer className={classes.scrollBar} style={{ overflowX: 'auto', overflowY: "hidden"}}>
                 <Table style={{width:columns.length*150}} aria-label="simple table">
                    <TableHead>
                        <TableRow style={{height:"32px"}}>
                        {
                            columns.map((n,index)=>{
                                return <TableCell 
                                style={n.cellStyle} 
                                width={"150px"}
                                size="small"
                                key={index}
                                >{n.title}</TableCell>
                                })
                        }
                        </TableRow>
                    </TableHead>
                 </Table>
                 </TableContainer>                   
                </>
        }
        </div>
    );
}

export default FooterAR1;